import { createLegend, LegendZone } from './legends';
import { ROOF_PITCH, ROOF_PITCH_DEGREES } from '../../tiltedRoof/roofPitch';
import { state } from '__common/store';
import { roofPitchUpdate } from '__common/utils/versionCompare/versionCompare';

export const hipRoofLegend = (roofPitch: string) => {
  if (!roofPitch || roofPitch === '---') {
    return null;
  }
  
  const { projectConfiguration: { projectVersion } } = state()

  const degressAngle =  roofPitchUpdate(projectVersion) ? ROOF_PITCH_DEGREES[roofPitch] : ROOF_PITCH[roofPitch];
  let legend: LegendZone[];

  if (degressAngle <= 45) {
    legend = [{
      zone: 3,
      name: '3',
    }, {
      zone: 5,
      name: '2r',
    }, {
      zone: 2,
      name: '2e',
    }, {
      zone: 1,
      name: '1',
    }];
  }
  
  if (degressAngle <= 27) {
    legend = [{
      zone: 2,
      name: '3, 2e, 2r',
    }, {
      zone: 1,
      name: '1',
    }];
  }

  if (degressAngle <= 20) {
    legend = [{
      zone: 3,
      name: '3, 2e',
    }, {
      zone: 2,
      name: '2r',
    }, {
      zone: 1,
      name: '1',
    }];
  }

  return createLegend(legend);
};
